// extracted by mini-css-extract-plugin
export default {"mainCont":"NoteItem_mainCont__fDF-W","note":"NoteItem_note__CmghV"};